/* eslint-disable jsx-a11y/iframe-has-title */
import { Modal, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionTypes from '../../actions/types';

const OITopModal = ({ onPlay, handleCloseVideo, styles }) => {
  const state = useSelector((state) => state.OpenInterestState);
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const setStateAction = (newState) =>
    dispatch({
      type: ActionTypes.SET_OPEN_INTREST,
      payload: newState,
    });
  return (
    <div>
      <Snackbar
        open={state.openError}
        autoHideDuration={5000}
        onClose={() => setStateAction({ openError: false })}
      >
        <Alert variant="filled" severity="warning">
          Click the Expiries you would like to graph, then click this button
          again
        </Alert>
      </Snackbar>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={onPlay}
        onClose={() => handleCloseVideo()}
      >
        <div style={styles.modalContent}>
          <iframe
            width={!appReducer.isMobile ? '800' : '400'}
            height={!appReducer.isMobile ? '400' : '200'}
            src="https://www.youtube.com/embed/lqqfcDh7QOA"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={styles.youtubeVideo}
          ></iframe>
        </div>
      </Modal>
    </div>
  );
};
export default OITopModal;



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/OITopModal.jsx